import { NEW_EHEALTH_PASSWORD, SessionAction } from "store/types/session.types";
import { Dispatch } from "react";

/** ---- ACTIONS ---- */
export const newEHealthPassword = (eHealthPassword: string) => {
  return (dispatch: Dispatch<SessionAction>) => {
    dispatchNewEhealthPassword(eHealthPassword)(dispatch);
  };
};

/** ---- DISPATCHERS ---- */
const dispatchNewEhealthPassword = (eHealthPassword: string) => {
  return (dispatch: Dispatch<SessionAction>) => {
    dispatch({ type: NEW_EHEALTH_PASSWORD, payload: eHealthPassword });
  };
};
